var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _line, _line2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotrip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 279,
    viewBox: "0 0 250 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 225L67 225C38.7157 225 24.5736 225 15.7868 216.213C7 207.426 7 193.284 7.00001 165L7.00001 77L80 77L80 215C80 220.523 84.4772 225 90 225V225Z",
    fill: "url(#paint0_linear_2873_12085)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 20C62 10.5719 62 5.85786 64.9289 2.92893C67.8579 0 72.5719 0 82 0H155C183.284 0 197.426 0 206.213 8.7868C215 17.5736 215 31.7157 215 60V165C215 193.284 215 207.426 206.213 216.213C197.426 225 183.284 225 155 225H52V225C53.1923 223.808 53.7884 223.212 54.3317 222.606C58.8957 217.518 61.5855 211.024 61.9559 204.199C62 203.387 62 202.544 62 200.858V20Z",
    fill: "url(#paint1_linear_2873_12085)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 20C62 10.5719 62 5.85786 64.9289 2.92893C67.8579 0 72.5719 0 82 0H155C183.284 0 197.426 0 206.213 8.7868C215 17.5736 215 31.7157 215 60V165C215 193.284 215 207.426 206.213 216.213C197.426 225 183.284 225 155 225H52V225C53.1923 223.808 53.7884 223.212 54.3317 222.606C58.8957 217.518 61.5855 211.024 61.9559 204.199C62 203.387 62 202.544 62 200.858V20Z",
    fill: "url(#paint2_radial_2873_12085)",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2873_12085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 23H129C157.284 23 171.426 23 180.213 31.7868C189 40.5736 189 54.7157 189 83V136C189 154.856 189 164.284 183.142 170.142C177.284 176 167.856 176 149 176H81.0552V30.0552C81.0552 26.1587 77.8965 23 74 23V23Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 23H129C157.284 23 171.426 23 180.213 31.7868C189 40.5736 189 54.7157 189 83V136C189 154.856 189 164.284 183.142 170.142C177.284 176 167.856 176 149 176H81.0552V30.0552C81.0552 26.1587 77.8965 23 74 23V23Z",
    stroke: "url(#paint3_linear_2873_12085)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_2873_12085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 0H177C205.284 0 219.426 0 228.213 8.7868C237 17.5736 237 31.7157 237 60V128C237 146.856 237 156.284 231.142 162.142C225.284 168 215.856 168 197 168H144C115.716 168 101.574 168 92.7868 159.213C84 150.426 84 136.284 84 108V10C84 4.47715 79.5228 0 74 0V0Z",
    fill: "#DCE1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 0H177C205.284 0 219.426 0 228.213 8.7868C237 17.5736 237 31.7157 237 60V128C237 146.856 237 156.284 231.142 162.142C225.284 168 215.856 168 197 168H144C115.716 168 101.574 168 92.7868 159.213C84 150.426 84 136.284 84 108V10C84 4.47715 79.5228 0 74 0V0Z",
    fill: "url(#paint4_linear_2873_12085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 0H177C205.284 0 219.426 0 228.213 8.7868C237 17.5736 237 31.7157 237 60V128C237 146.856 237 156.284 231.142 162.142C225.284 168 215.856 168 197 168H144C115.716 168 101.574 168 92.7868 159.213C84 150.426 84 136.284 84 108V10C84 4.47715 79.5228 0 74 0V0Z",
    fill: "url(#paint5_linear_2873_12085)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M179.586 107.167H144.414C130.667 107.167 127.69 99.2942 128.826 89.6592L132.351 60.2842C133.252 52.6859 134.583 46.4584 147.9 46.4584H176.1C189.417 46.4584 190.748 52.6859 191.649 60.2842L194.587 84.7634L195.174 89.6592C195.213 89.9725 195.252 90.2858 195.292 90.5992C196.114 99.8033 192.903 107.167 179.586 107.167Z",
    fill: "#00A6A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.667 55.2709C176.061 55.2709 174.729 53.9392 174.729 52.3334V38.625C174.729 34.395 172.105 31.7709 167.875 31.7709H156.125C151.895 31.7709 149.271 34.395 149.271 38.625V52.3334C149.271 53.9392 147.939 55.2709 146.333 55.2709C144.727 55.2709 143.396 53.9392 143.396 52.3334V38.625C143.396 31.1442 148.644 25.8959 156.125 25.8959H167.875C175.356 25.8959 180.604 31.1442 180.604 38.625V52.3334C180.604 53.9392 179.272 55.2709 177.667 55.2709Z",
    fill: "#00A6A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.292 90.5991C195.174 90.6383 195.057 90.6383 194.939 90.6383H146.333C144.727 90.6383 143.396 89.3066 143.396 87.7008C143.396 86.0558 144.727 84.7633 146.333 84.7633H194.587L195.174 89.6591C195.213 89.9725 195.252 90.2858 195.292 90.5991Z",
    fill: "#00A6A6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 136.5,
    y1: 127.5,
    x2: 188.5,
    y2: 127.5,
    stroke: "#00A6A6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160.5,
    y1: 140.5,
    x2: 188.5,
    y2: 140.5,
    stroke: "#00A6A6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2873_12085)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 262,
    rx: 115,
    ry: 7,
    fill: "url(#paint6_linear_2873_12085)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2873_12085",
    x: 54,
    y: 2.5,
    width: 155.5,
    height: 194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_2873_12085"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_2873_12085",
    x: 70,
    y: -4,
    width: 167,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2873_12085"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745098 0 0 0 0 0.745098 0 0 0 0 0.745098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2873_12085",
    result: "effect2_innerShadow_2873_12085"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745098 0 0 0 0 0.745098 0 0 0 0 0.745098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2873_12085",
    result: "effect3_innerShadow_2873_12085"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2873_12085",
    x: 0,
    y: 245,
    width: 250,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_2873_12085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2873_12085",
    x1: 48.5,
    y1: 205,
    x2: 48.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE1E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2873_12085",
    x1: 138.5,
    y1: 0,
    x2: 138.5,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#00A6A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2873_12085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219 175) rotate(159.561) scale(85.9084 64.117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2873_12085",
    x1: 210.166,
    y1: 200.589,
    x2: 125.864,
    y2: 146.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2873_12085",
    x1: 237,
    y1: 192,
    x2: 91,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2873_12085",
    x1: 155.5,
    y1: 0,
    x2: 155.5,
    y2: 168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE1E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2873_12085",
    x1: 125,
    y1: 255,
    x2: 125,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotrip);
export default __webpack_public_path__ + "static/media/notrip.988739ead635475bf36478d34a24281c.svg";
export { ForwardRef as ReactComponent };